// ABOUTME: The coaching segment's Nylas booking: the choose-time prompt, then what was booked
// ABOUTME: After a booking the segment records it and shows the scheduled sessions in its place
import { BookingResult } from '@execonline-inc/slot-picker.private';
import { Maybe } from 'maybeasy';
import { observer } from 'mobx-react';
import * as React from 'react';
import { useState } from 'react';
import { currentUserStore } from '../../CurrentUser/Store';
import { Link } from '../../Resource/Types';
import SegmentStore from '../../SegmentStore';
import CoachingScheduler from '../CoachingScheduler';
import CoachingReadyView from './CoachingReadyView';
import CoachingScheduledView from './CoachingScheduledView';

interface Props {
  schedulerLink: Link;
  participantEmail: string;
  segmentStore: Maybe<SegmentStore>;
}

const SegmentCoachingScheduler: React.FC<Props> = ({
  schedulerLink,
  participantEmail,
  segmentStore,
}) => {
  const [booked, setBooked] = useState<BookingResult[]>([]);
  const locale = currentUserStore.preferredLanguage.getOrElseValue('en');

  return booked.length > 0 ? (
    <CoachingScheduledView booked={booked} locale={locale} />
  ) : (
    <CoachingScheduler
      schedulerLink={schedulerLink}
      participantEmail={participantEmail}
      onBooked={(sessions) => {
        setBooked(sessions);
        segmentStore.do((store) => {
          store.scheduleSession();
        });
      }}
    >
      {(open) => <CoachingReadyView buttonId="coaching-scheduler-button" onClick={open} />}
    </CoachingScheduler>
  );
};

export default observer(SegmentCoachingScheduler);
